import { render, staticRenderFns } from "./data-card.vue?vue&type=template&id=6fc574df&scoped=true"
import script from "./data-card.vue?vue&type=script&lang=js"
export * from "./data-card.vue?vue&type=script&lang=js"
import style0 from "./data-card.vue?vue&type=style&index=0&id=6fc574df&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc574df",
  null
  
)

export default component.exports